import { VPA_VERIFY } from "../api/constApi";
import { apiInstance } from "./axiosApi";

export const getVpaVerify = (payload) => {
  return apiInstance.post(VPA_VERIFY, payload);
};
